import React from 'react';
import { motion } from 'framer-motion';
import { FaSpinner } from 'react-icons/fa';
import styled from 'styled-components';

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  width: 100%;
  
  svg {
    color: #3454D1;
    font-size: 2.5rem;
  }
  
  p {
    margin-top: 1rem;
    color: #4B5563;
    font-size: 1rem;
  }
`;

const spinTransition = {
  repeat: Infinity,
  duration: 1.5,
  ease: "easeInOut"
};

function Loading() {
  return (
    <LoadingContainer>
      <motion.div
        animate={{ rotate: 360 }}
        transition={spinTransition}
      >
        <FaSpinner />
      </motion.div>
      <p>Carregando...</p>
    </LoadingContainer>
  );
}

export default Loading; 